import { Chip, ChipProps } from "@mui/material";

import { TicketStatus, TicketType } from "features/support/tickets";

const STATUS_COLORS: Record<TicketStatus, ChipProps["color"]> = {
  New: "default",
  "In Progress": "info",
  Done: "success",
  Error: "error",
};

export const TicketStatusChip = ({ status }: { status: TicketStatus }) => (
  <Chip size="small" label={status} color={STATUS_COLORS[status]} />
);

export const TicketTypeChip = ({ type }: { type: TicketType }) => (
  <Chip
    size="small"
    variant="outlined"
    label={type}
    color={type === "Bug" ? "warning" : "primary"}
  />
);

/** The browser's own locale, so a date reads the way the user writes it. */
export const formatTicketDate = (iso: string, withTime = false): string => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return "--";
  }
  return withTime ? date.toLocaleString() : date.toLocaleDateString();
};
